<template>
  <v-dialog
    v-model="dialog"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
    class="pb-6"
    max-width="1024"
    scrollable
  >
    <v-card v-show="data.length != 0">
      <v-toolbar style="max-height: 56px">
        {{ $route.query.event }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text class="px-4" style="height: 768px">
        <div class="pt-4">
          {{ $t("schedule") }}: {{ $route.query.date }} ({{ $gmt() }})
        </div>
        <div class="py-1">
          {{ $t("tournament") }}:
          {{ $route.query.tournament }}
        </div>

        <v-btn
          class="mb-1"
          small
          color="primary"
          @click="handleShowMarketsProfit"
          :disabled="disableShowMarketsProfit"
          v-if="!hideShowMarketProfitButton"
        >
          {{
            showMarketsProfit
              ? $t("hideEstimatedProfit")
              : $t("showEstimatedProfit")
          }}
        </v-btn>
        <v-tooltip bottom v-if="!hideShowMarketProfitButton">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" class="mb-1 ml-2" color="primary">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t("surebetFormula") }}</span>
        </v-tooltip>
        <!-- <div class="caption">{{ $t("surebetFormula") }}</div> -->

        <!--*********************************************************************************************************-->
        <!--************ Select Market ******************************************************************************-->
        <!--*********************************************************************************************************-->
        <v-row justify="end">
          <v-col cols="12" sm="12" md="6">
            <v-select
              solo-inverted
              :items="items"
              item-text="text"
              item-value="value"
              clearable
              @change="selectMarket"
              :label="$t('searchToMarket')"
              style="height: 50px"
              dense
            ></v-select>
          </v-col>
        </v-row>
        <!--END SELECT MARKERT *********************************************************************************-->

        <!--*********************************************************************************************************-->
        <!--************ Cards Odds    ******************************************************************************-->
        <!--*********************************************************************************************************-->
        <v-card
          class="mb-4"
          outlined
          tile
          v-for="(market, index) in data"
          :key="index"
        >
          <!-- TITLE CARD *********************************************************************************-->
          <v-toolbar dense elevation="0">
            <v-toolbar-title>
              {{ market.data.name_market || "" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-switch
              class="mt-6"
              v-model="market.activeMarket"
              :disabled="!canChangeStatusMarket"
              @change="
                enableDesableMarket(
                  market.id_market,
                  $route.params.id,
                  market.activeMarket
                )
              "
            ></v-switch>
          </v-toolbar>
          <v-divider></v-divider>

          <div
            class="
              d-flex
              flex-column
              pt-4
              pb-2
              px-4
            "
            v-if="market.id_market == 1 && showMarketsProfit"
          >
            <!-- aqui -->
            <div class="d-flex" :class="{ 'flex-column': isXsmall }">
              <div
                class="
                  d-flex
                  flex-column
                "
                style="row-gap: 16px"
              >
                <!-- Lucro pre-jogo, flag superOdd e checkbox -->
                <div
                  class="
                    d-flex
                    gap-8px
                    py-1
                    pl-2
                  "
                  :class="isXsmall ? 'flex-column' : 'align-end'"
                >
                  <!-- Lucro pre-jogo -->
                  <div
                    v-if="eventInProgress === false"
                    class="
                      d-flex
                      align-end
                      gap-8px
                    "
                  >
                    <div>
                      {{ $t("profit.prematch") }}
                    </div>
                    <div
                      :class="
                        isXsmall
                          ? `d-flex
                        flex-row-reverse
                        align-center
                        gap-8px
                        `
                          : 'd-flex flex-column align-center'
                      "
                    >
                      <div
                        v-if="
                          isSuperOddUI(market.data.profit.prematch.value) &&
                            idSport == 6046 &&
                            $permission('125')
                        "
                        class="super-odd-flag pb-1"
                      >
                        SuperOdd!
                      </div>
                      <div :class="market.data.profit.prematch.class">
                        {{ market.data.profit.prematch.value }}
                      </div>
                    </div>
                  </div>

                  <!-- Checkbox superOdd -->
                  <div
                    v-if="
                      isSuperOddUI(market.data.profit.prematch.value) &&
                        idSport == 6046 &&
                        $permission('125')
                    "
                    class="d-flex flex-column"
                    style="row-gap: 16px"
                  >
                    <div class="d-flex align-end">
                      <div>
                        <v-checkbox
                          v-model="showSuperOdd"
                          hide-details
                          dense
                          class="mt-0 pt-0"
                          @click="changeSuperOdds()"
                          :disabled="!market.activeMarket"
                        >
                          <template v-slot:label>
                            <div
                              :style="
                                !market.activeMarket
                                  ? `font-size: 14px;
                                  color: rgba(255, 255, 255, 0.3);`
                                  : `font-size: 14px;
                                  color: #FFFFFF;`
                              "
                            >
                              {{ $t("profit.showSuperOdd") }}
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                      <div>
                        <v-tooltip right content-class="tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on="on"
                              v-bind="attrs"
                              class="mb-1 ml-2"
                              color="primary mb-2"
                              small
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            {{ $t("profit.tooltip") }}
                          </span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- lucro ao vivo -->
                <div
                  class="
                    d-flex
                    gap-8px
                    py-1
                    px-2
                  "
                >
                  <div>{{ $t("profit.live") }}</div>
                  <div :class="market.data.profit.live.class">
                    {{ market.data.profit.live.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-row
            no-gutters
            class="d-flex align-center py-2 px-4 hover-row justify-space-between"
            v-for="(odd, indexRow) in market.odds"
            :key="indexRow"
            :style="
              `flex-wrap: ${$vuetify.breakpoint.mobile ? 'wrap' : 'inherit'}`
            "
          >
            <v-col class="px-2 d-flex align-center">
              <div
                v-text="odd.data.name_outcome"
                class="mt-2"
                style="font-size: 16px"
              ></div>
              <div
                v-if="$vuetify.breakpoint.mobile === false"
                class="d-flex ml-auto"
                :class="{
                  'mt-4': indexRow === 0,
                }"
              >
                <v-chip
                  v-if="eventInProgress === false"
                  :class="{
                    'text-decoration-line-through': odd.active != 1,
                  }"
                  class="chip ml-2"
                  :color="
                    eventInProgress
                      ? '#424242'
                      : !market.activeMarket
                      ? 'gray'
                      : 'info'
                  "
                  outlined
                  :disabled="!market.activeMarket"
                >
                  Odd: {{ odd.odd_price > 1.01 ? odd.odd_price : 1.01 }}
                </v-chip>

                <v-chip
                  :class="{
                    'text-decoration-line-through': odd.active != 1,
                  }"
                  class="chip ml-2"
                  :color="!market.activeMarket ? 'gray' : 'green accent-4'"
                  outlined
                  :disabled="!market.activeMarket"
                >
                  Odd live:
                  {{ odd.odd_price_live > 1.01 ? odd.odd_price_live : 1.01 }}
                </v-chip>
              </div>
            </v-col>

            <div v-if="$vuetify.breakpoint.mobile === true">
              <v-chip
                v-if="eventInProgress === false"
                :class="{
                  'text-decoration-line-through': odd.active != 1,
                }"
                class="chip mt-3"
                :color="
                  eventInProgress
                    ? '#424242'
                    : !market.activeMarket
                    ? 'gray'
                    : 'info'
                "
                outlined
                :disabled="!market.activeMarket"
              >
                Odd: {{ odd.odd_price > 1.01 ? odd.odd_price : 1.01 }}
              </v-chip>

              <v-chip
                :class="{
                  'text-decoration-line-through': odd.active != 1,
                }"
                class="chip mt-3 ml-2"
                :color="!market.activeMarket ? 'gray' : 'green accent-4'"
                outlined
                :disabled="!market.activeMarket"
              >
                Odd live:
                {{ odd.odd_price_live > 1.01 ? odd.odd_price_live : 1.01 }}
              </v-chip>
            </div>

            <div
              class="d-flex align-center justify-space-between"
              :class="{
                'flex-column':
                  $vuetify.breakpoint.mobile || odd.alertMarginCashout > 0,
              }"
              :style="
                $vuetify.breakpoint.mobile ? 'width: 100% !important;' : ''
              "
            >
              <v-form
                :style="{
                  width: $vuetify.breakpoint.mobile
                    ? '100%'
                    : showFixedPrematchOdd(market.id_market)
                    ? '600px'
                    : '',
                  gap: '8px',
                }"
                class="d-flex px-2 mt-2"
                :class="{
                  'flex-column': $vuetify.breakpoint.mobile,
                }"
                v-model="valid"
                onSubmit="return false;"
                v-on:submit.prevent="
                  [
                    updateOdd(
                      $route.params.id,
                      odd.id_outcome,
                      odd.margin_event,
                      odd.id_odd,
                      'key_enter',
                      odd.margin_event_live,
                      odd.fixed_prematch_odd,
                      market.id_market
                    ),
                  ],
                    (disabled = true)
                "
              >
                <div>
                  <p
                    v-if="
                      eventInProgress === false &&
                        ($vuetify.breakpoint.mobile || indexRow === 0)
                    "
                    :class="
                      $vuetify.breakpoint.mobile ? 'text-left' : 'text-center'
                    "
                    :style="
                      eventInProgress || !market.activeMarket
                        ? 'color: rgba(255, 255, 255, 0.3);'
                        : ''
                    "
                  >
                    {{ $t("preGame") }}
                  </p>
                  <v-text-field
                    v-if="eventInProgress === false"
                    :id="odd.id_odd"
                    v-model="odd.margin_event"
                    @focus="odd.oldMargin = odd.margin_event"
                    @change="marginChanged(odd, index)"
                    type="number"
                    class="relative mt-4"
                    clearable
                    @keypress="isNumber($event)"
                    @blur="
                      [
                        updateOdd(
                          $route.params.id,
                          odd.id_outcome,
                          odd.margin_event,
                          odd.id_odd,
                          null,
                          odd.margin_event_live,
                          odd.fixed_prematch_odd,
                          market.id_market
                        ),
                        formatDecimal,
                      ]
                    "
                    @click:clear="
                      updateOdd(
                        $route.params.id,
                        odd.id_outcome,
                        '0',
                        odd.id_odd,
                        null,
                        odd.margin_event_live,
                        odd.fixed_prematch_odd,
                        market.id_market
                      )
                    "
                    prepend-inner-icon="mdi-percent-outline"
                    solo-inverted
                    required
                    dense
                    :rules="[porcent]"
                    :disabled="
                      loading ||
                        (odd.fixed_prematch_odd ? true : false) ||
                        eventInProgress ||
                        !market.activeMarket ||
                        disabled ||
                        !canChangeOutcomeMarket
                    "
                    :hide-details="odd.alertMarginCashout > 0 ? true : false"
                  ></v-text-field>
                </div>

                <div v-if="showFixedPrematchOdd(market.id_market)">
                  <p
                    v-if="
                      eventInProgress === false &&
                        ($vuetify.breakpoint.mobile || indexRow === 0)
                    "
                    :class="
                      $vuetify.breakpoint.mobile ? 'text-left' : 'text-center'
                    "
                    :style="
                      eventInProgress || !market.activeMarket
                        ? 'color: rgba(255, 255, 255, 0.3);'
                        : ''
                    "
                  >
                    {{ $t("fixedOdd") }} ({{ $t("preGame") }})
                  </p>
                  <v-text-field
                    v-if="eventInProgress === false"
                    :id="odd.id_odd"
                    v-model="odd.fixed_prematch_odd"
                    type="text"
                    class="relative mt-4"
                    clearable
                    @keypress="isNumber($event, true)"
                    @blur="
                      updateFixedPrematchOdd(
                        odd,
                        indexRow,
                        index,
                        market.id_market
                      )
                    "
                    @click:clear="
                      updateOdd(
                        $route.params.id,
                        odd.id_outcome,
                        odd.margin_event,
                        odd.id_odd,
                        null,
                        odd.margin_event_live,
                        '0',
                        market.id_market
                      )
                    "
                    solo-inverted
                    required
                    dense
                    :rules="[minOdd, maxOdd]"
                    :disabled="
                      eventInProgress ||
                        !market.activeMarket ||
                        disabled ||
                        !canChangeOutcomeMarket
                    "
                  ></v-text-field>
                </div>

                <div>
                  <p
                    v-if="$vuetify.breakpoint.mobile || indexRow === 0"
                    :class="
                      $vuetify.breakpoint.mobile ? 'text-left' : 'text-center'
                    "
                    :style="
                      !market.activeMarket
                        ? 'color: rgba(255, 255, 255, 0.3);'
                        : ''
                    "
                  >
                    {{ $t("Live") }}
                  </p>
                  <v-text-field
                    :id="odd.id_odd"
                    v-model="odd.margin_event_live"
                    @focus="odd.oldMarginLive = odd.margin_event_live"
                    @change="liveMarginChanged(odd, index)"
                    type="number"
                    class="relative mt-4"
                    clearable
                    @keypress="isNumber($event)"
                    @blur="
                      [
                        updateOdd(
                          $route.params.id,
                          odd.id_outcome,
                          odd.margin_event,
                          odd.id_odd,
                          null,
                          odd.margin_event_live,
                          odd.fixed_prematch_odd,
                          market.id_market
                        ),
                        formatDecimal,
                      ]
                    "
                    @click:clear="
                      updateOdd(
                        $route.params.id,
                        odd.id_outcome,
                        odd.margin_event,
                        odd.id_odd,
                        null,
                        '0',
                        odd.fixed_prematch_odd,
                        market.id_market
                      )
                    "
                    prepend-inner-icon="mdi-percent-outline"
                    solo-inverted
                    required
                    dense
                    :rules="[porcent]"
                    :disabled="
                      !market.activeMarket ||
                        disabled ||
                        !canChangeOutcomeMarket
                    "
                    :hide-details="odd.alertMarginCashout > 0 ? true : false"
                  ></v-text-field>
                </div>
              </v-form>
              <v-alert
                v-if="odd.alertMarginCashout > 0"
                class="pa-2 mt-2"
                type="info"
                dense
                border="left"
                text
                style="font-size: 1em; max-width: 450px;"
              >
                <span v-if="!odd.isAlertLive">
                  {{
                    $t("marginChangedAlertMessage", {
                      type: $t("preGame").toLowerCase(),
                      oldMargin: Number(odd.oldMargin).toFixed(2),
                      currentMargin: Number(odd.margin_event).toFixed(2),
                    })
                  }}
                </span>
                <span v-else>
                  {{
                    $t("marginChangedAlertMessage", {
                      type: $t("live").toLowerCase(),
                      oldMargin: Number(odd.oldMarginLive).toFixed(2),
                      currentMargin: Number(odd.margin_event_live).toFixed(2),
                    })
                  }}
                </span>
              </v-alert>
            </div>
          </v-row>
        </v-card>
        <!--END CARDS ODDS *********************************************************************************-->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";

var blur = false;
var inProgress = false;
export default {
  name: "CollaboratorEventEditOdds",

  data: () => ({
    data: [],
    valid: true,
    copyData: [],
    eventOff: null,
    items: [],
    // rules: {
    //   porcent: (value) => value <= 100 || "Campo permitido até 100%",
    // },
    showMarketsProfit: false,
    firstProfitShowed: false,
    disableShowMarketsProfit: false,
    hideShowMarketProfitButton: false,
    disabled: false,
    minOdd: validate.minFixedOddValue,
    maxOdd: validate.maxFixedOddValue,
    initialFixedPrematchOdds: [],
    loading: false,
    showSuperOdd: false,
    hasSuperOdd: null,
  }),

  computed: {
    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    dialog() {
      return this.$store.state.showDialogEditOdds;
    },

    porcent() {
      return (value) => value <= 100 || this.$t("allowedFieldUpTo100");
    },

    eventInProgress() {
      return this.$route.query.status == "2";
    },

    canChangeStatusMarket() {
      return this.$permission("80");
    },

    canChangeOutcomeMarket() {
      return this.$permission("81");
    },

    preMatch() {
      return this.$route.query.status == "1";
    },

    idSport() {
      return this.$route.query.id_sport;
    },

    idEvent() {
      return this.$route.params.id;
    },
  },

  mounted() {
    this.getEditOdds();
    this.getSuperOdds();
    if (this.$route.query.event) {
      this.$store.commit(`showDialogEditOdds`, true);
    }
  },

  watch: {
    hasSuperOdd(val) {
      val ? (this.showSuperOdd = true) : (this.showSuperOdd = false);
    },
  },

  methods: {
    marginChanged(odd, marketIndex) {
      clearTimeout(odd.lastMarginChangedTimeout);

      const oldMargin = Number(odd.oldMargin);

      const alertMarginCashout =
        oldMargin < 0 && Number(odd.margin_event) > oldMargin;

      let oddId = odd.id_odd;

      odd.alertMarginCashout = alertMarginCashout ? oddId : 0;
      odd.isAlertLive = false;

      let lastMarginChangedTimeout = setTimeout(() => {
        this.data[marketIndex].odds = this.data[marketIndex].odds.map((odd) => {
          if (odd.id_odd === oddId) {
            odd.alertMarginCashout = 0;
          }

          return odd;
        });
      }, 7000);

      odd.lastMarginChangedTimeout = lastMarginChangedTimeout;
    },

    liveMarginChanged(odd, marketIndex) {
      clearTimeout(odd.lastLiveMarginChangedTimeout);

      const oldMarginLive = Number(odd.oldMarginLive);

      const alertMarginCashout =
        oldMarginLive < 0 && Number(odd.margin_event_live) > oldMarginLive;

      let oddId = odd.id_odd;

      odd.alertMarginCashout = alertMarginCashout ? oddId : 0;
      odd.isAlertLive = true;

      let lastLiveMarginChangedTimeout = setTimeout(() => {
        this.data[marketIndex].odds = this.data[marketIndex].odds.map((odd) => {
          if (odd.id_odd === oddId) {
            odd.alertMarginCashout = 0;
          }

          return odd;
        });
      }, 7000);

      odd.lastLiveMarginChangedTimeout = lastLiveMarginChangedTimeout;
    },

    showFixedPrematchOdd(market_id) {
      if (market_id != "1") {
        return false;
      }

      const allowedOperators = [
        "sys",
        "homolog",
        "pagamaissports",
        "esportenet",
      ];

      return (
        allowedOperators.includes(
          JSON.parse(localStorage.getItem("user_data")).db_name
        ) && this.eventInProgress === false
      );
    },

    handleShowMarketsProfit() {
      if (this.firstProfitShowed) {
        this.showMarketsProfit = !this.showMarketsProfit;
        return;
      }

      const index = this.data.findIndex((market) => market.id_market == 1);

      let atLeastOneOddSuspendedOrSettled = false;

      for (let odd of this.data[index].odds) {
        if (odd.active != 1) {
          atLeastOneOddSuspendedOrSettled = true;
          break;
        }
      }

      if (atLeastOneOddSuspendedOrSettled) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("cantCalculateSurebet"),
          color: "warning",
        });

        return;
      }

      this.firstProfitShowed = true;
      this.showMarketsProfit = true;
    },

    updateMarketProfit(index) {
      const odds = this.data[index].odds;
      this.data[index].data.profit.prematch = this.getProfitByOdds(odds, false);
      this.data[index].data.profit.live = this.getProfitByOdds(odds, true);
      const profitPrematch = this.data[index].data.profit.prematch.value;
      this.handleSuperOdd(profitPrematch);
    },

    handleSuperOdd(profitPreMatch) {
      let cleanedString = profitPreMatch.replace(/[+%]/g, "");
      const isProfitSuperOdd = Number(cleanedString) < 4;

      if (isProfitSuperOdd && this.showSuperOdd) {
        this.hasSuperOdd = true;
      }

      if (!isProfitSuperOdd && this.showSuperOdd) {
        this.showSuperOdd = false;
        this.hasSuperOdd = false;
        this.debounceChangeSuperOdds();
      }
    },

    debounceChangeSuperOdds() {
      clearTimeout(this.changeSuperOddsTimeout);

      this.changeSuperOddsTimeout = setTimeout(() => {
        this.changeSuperOdds();
      }, 500);
    },

    getProfitByOdds(odds, live) {
      const field = live ? "odd_price_live" : "odd_price";

      let inverseOddsSum = 0;

      for (let i = 0; i < odds.length; i++) {
        inverseOddsSum += 1 / Number(odds[i][field]);
      }

      const profit = ((inverseOddsSum - 1) / inverseOddsSum) * 100;

      return {
        value: `${
          profit > 0
            ? `+${this.decimalAdjustment(profit)}`
            : this.decimalAdjustment(profit)
        }%`,
        class:
          profit > 0 ? "green--text" : profit < 0 ? "red--text" : "grey--text",
      };
    },

    decimalAdjustment: function(num) {
      return (-(Math.round(-num + "e+2") + "e-2")).toFixed(2);
    },

    closeDialog() {
      this.data = [];
      this.items = [];
      this.$router.go(-1);
      this.$store.commit("showDialogEditOdds", false);
    },

    async getEditOdds() {
      const id_event = this.$route.params.id;
      const request = await this.$request.post("/colab/events/editOdds", {
        id_event,
      });

      if (request.length == 0) {
        this.closeDialog();
        return;
      }

      this.data = request.dados.markets;

      let hasMarket = false;

      // Build infos
      this.data.forEach((item, index) => {
        item.data = this.$infoTable.markets(item.id_market);
        item.data.profit = {
          class: "",
          value: "",
        };

        if (item.id_market == 1) {
          hasMarket = true;
          if (item.odds.length != 3) {
            this.disableShowMarketsProfit = true;
          } else {
            this.updateMarketProfit(index);
          }
        }

        const selectedsOutcome = item.odds
          .map((outcome) =>
            outcome.margin_event == "100.00" &&
            outcome.margin_event_live == "100.00"
              ? true
              : false
          )
          .reduce((a, b) => a && b);
        item.activeMarket = !selectedsOutcome;

        this.items.push({
          text: this.$infoTable.markets(item.id_market).name_market,
          value: item.id_market,
        });
        item.odds.forEach((itemOdd) => {
          itemOdd.data = this.$infoTable.outcomes(itemOdd.id_outcome);
          itemOdd.data.model = "";
        });
      });

      if (!hasMarket) {
        this.hideShowMarketProfitButton = true;
      }

      this.copyData = this.data;

      const finalResultMarket = this.copyData.find(
        ({ id_market }) => id_market == 1
      );

      const odds = [];

      if (finalResultMarket) {
        finalResultMarket.odds.length > 0 &&
          finalResultMarket.odds.forEach((odd) => {
            odds.push({
              id_outcome: odd.id_outcome,
              fixed_prematch_odd: odd.fixed_prematch_odd,
            });
          });

        this.initialFixedPrematchOdds = odds;
      }
    },

    selectMarket(id_market) {
      if (id_market && id_market != 1) {
        this.disableShowMarketsProfit = true;
      } else {
        this.disableShowMarketsProfit = false;
      }
      this.data = id_market
        ? this.copyData.filter((item) => item.id_market == id_market)
        : this.copyData;
    },

    async updateOdd(
      id_event,
      id_outcome,
      margin_value,
      id_odd,
      type,
      margin_event_live,
      fixed_prematch_odd,
      market_id
    ) {
      if (!this.canChangeOutcomeMarket) {
        return;
      }
      if (inProgress == true) {
        return;
      }

      if (!this.valid || blur) {
        this.disabled = false;
        blur = false;
        return;
      }

      //   if (
      //     margin_value == "" ||
      //     margin_value == null ||
      //     margin_event_live == "" || margin_event_live == null
      //   ) {
      //     this.disabled = false;
      //     blur = false;
      //     return;
      //   }

      inProgress = true;

      const body = {
        id_event,
        id_outcome,
        margin_value: margin_value || 0,
        margin_event_live: margin_event_live || 0,
      };

      if (this.showFixedPrematchOdd(market_id)) {
        body.fixed_prematch_odd = fixed_prematch_odd || 0;
      }

      const initialOdd = this.initialFixedPrematchOdds.find(
        (odd) => odd.id_outcome == id_outcome
      );

      if (initialOdd) {
        if (
          initialOdd.fixed_prematch_odd &&
          Number(initialOdd.fixed_prematch_odd) > 1.01
        ) {
          if (body.fixed_prematch_odd == 0) {
            body.margin_value = 0;
          }
        }
      }

      this.loading = true;

      this.$request
        .post("/colab/events/changeOutcomeEvent", body)
        .then((res) => {
          if (res.length == 0) {
            return;
          }
          inProgress = true;

          this.data.forEach((item, marketIndex) => {
            item.odds.forEach((itemOdd) => {
              if (itemOdd.id_outcome == id_outcome) {
                if (res.dados.odd_price) {
                  itemOdd.odd_price = res.dados.odd_price;
                }
                if (res.dados.odd_price_live) {
                  itemOdd.odd_price_live = res.dados.odd_price_live;
                }

                if (res.dados.margin_value || res.dados.margin_value == 0) {
                  itemOdd.margin_event = res.dados.margin_value;

                  if (
                    this.showFixedPrematchOdd(market_id) &&
                    body.fixed_prematch_odd &&
                    Number(body.fixed_prematch_odd) > 0
                  ) {
                    itemOdd.oldMargin = itemOdd.margin_event;
                    this.marginChanged(itemOdd, marketIndex);
                  }
                }

                if (item.id_market == 1) {
                  this.updateMarketProfit(marketIndex);
                }
              }
            });
          });

          this.initialFixedPrematchOdds.forEach((odd) => {
            if (odd.id_outcome == id_outcome) {
              if (res.dados.odd_price) {
                odd.odd_price = res.dados.odd_price;
              }

              if (res.dados.odd_price_live) {
                odd.odd_price_live = res.dados.odd_price_live;
              }

              odd.margin_event = body.margin_value;
              odd.fixed_prematch_odd = body.fixed_prematch_odd;

              if (market_id) {
                this.updateMarketProfit(0);
              }
            }
          });

          // Alert
          var msg = this.$t("changeOutcomeEvent");
          this.$store.commit("setFeedbackSnack", {
            msg: msg,
            color: "green",
          });
        })
        .then(() => {
          // Retira Focus do input ao clicar em enter
          if (type == "key_enter") {
            document.getElementById(id_odd).blur();
            blur = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.disabled = false;
          inProgress = false;
        });
    },

    enableDesableMarket(id_market, id_event, switchValue) {
      if (switchValue == false && this.showSuperOdd) {
        this.showSuperOdd = false;
        this.changeSuperOdds();
      }
      const margin_value = switchValue ? 0 : 100;

      this.$axios
        .post(
          "/colab/events/changeMarketEvent",
          this.$formdata({
            id_market,
            id_event,
            margin_value,
            margin_event_live: margin_value,
          })
        )
        .then((response) => {
          response.data.dados.forEach((outcome) => {
            this.data.forEach((item) => {
              item.odds.forEach((itemOdd) => {
                if (itemOdd.id_outcome == outcome.id_outcome) {
                  itemOdd.odd_price = outcome.odd_price;
                  itemOdd.odd_price_live = outcome.odd_price_live;
                  itemOdd.margin_event = margin_value;
                  itemOdd.margin_event_live = margin_value;
                }
              });
            });
          });
        });
    },

    updateFixedPrematchOdd(odd, oddIndex, marketIndex, marketId) {
      const newValue = this.twoDecimals(
        odd.fixed_prematch_odd,
        oddIndex,
        marketIndex
      );

      this.updateOdd(
        this.$route.params.id,
        odd.id_outcome,
        odd.margin_event,
        odd.id_odd,
        null,
        odd.margin_event_live,
        newValue,
        marketId
      );
    },

    // Colocalem formato decimal
    formatDecimal(field) {
      if (!field.isDecimal) return;
      field.model = Number(field.model.replace(",", ".")).toFixed(2);
    },

    // Verifica se é numero
    isNumber: function(evt, fixed_prematch_odd = false) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      const decimalKeys = [".", ","];

      if (decimalKeys.includes(evt.key) && fixed_prematch_odd) {
        return true;
      }

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    twoDecimals(value, oddIndex, marketIndex) {
      value = value.replace(",", ".");

      function roundToFloor(value) {
        return value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
      }

      if (value) {
        this.data[marketIndex].odds[oddIndex].fixed_prematch_odd = roundToFloor(
          parseFloat(value)
        );

        this.$forceUpdate();

        return this.data[marketIndex].odds[oddIndex].fixed_prematch_odd;
      }
    },

    isSuperOddUI(profitPreMatch) {
      let cleanedString = profitPreMatch.replace(/[+%]/g, "");
      let isSuperOdd = Number(cleanedString) < 4 ? true : false;
      if (!isSuperOdd) {
        this.showSuperOdd = false;
      }

      return isSuperOdd;
    },

    getSuperOdds() {
      const body = {
        id_event: this.idEvent,
        id_market: "1",
      };
      this.$axios
        .post("colab/events/getSuperOdds", this.$formdata(body))
        .then((res) => {
          res.data.dados.super_odds == "1"
            ? (this.hasSuperOdd = true)
            : (this.hasSuperOdd = false);
        })
        .catch(() => {})
        .finally(() => {});
    },

    changeSuperOdds() {
      const body = {
        id_event: this.idEvent,
        id_market: "1",
        super_odds: this.showSuperOdd == true ? "1" : "0",
      };
      this.$axios
        .post("colab/events/changeSuperOdds", this.$formdata(body))
        .then(() => {
          let message =
            this.showSuperOdd == true
              ? this.$t("profit.displayingSuperOdd")
              : this.$t("profit.hidingSuperOdd");

          this.$store.commit("setFeedbackSnack", {
            msg: message,
            color: "green",
          });
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<style>
.super-odd-flag {
  color: #fff;
  text-shadow: 0px 0px 3.5px #fff;
  font-family: Roboto;
  font-size: 10px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 1px;
}

.gap-8px {
  gap: 8px;
}

.tooltip {
  width: 260px !important;
}
</style>
